import React from "react";
import {
  FaLanguage, FaCode, FaBook, FaRunning, FaPlane,
  FaMicrophone, FaRobot, FaSeedling, FaBullseye,
} from "react-icons/fa";
import "./Interests.css";

// ─── Interest data ────────────────────────────────────────────────────────
const INTERESTS = [
  {
    icon: <FaLanguage />,
    color: "#ff69b4",
    name: "Languages & Cultures",
    description: "Currently learning Korean and improving Turkish and Spanish. Fascinated by how language shapes identity, humour, and the way people see the world.",
    tags: ["Korean", "Arabic", "French", "Spanish", "Turkish", "English"],
  },
  {
    icon: <FaRobot />,
    color: "#7b9eff",
    name: "AI & Future Tech",
    description: "Closely following advances in LLMs, generative AI, and computer vision. Building AI-powered platforms in my day-to-day work — it's both my field and my passion.",
    tags: ["LLMs", "Generative AI", "Computer Vision", "NLP"],
  },
  {
    icon: <FaCode />,
    color: "#88ffbb",
    name: "Building Things",
    description: "Coding side projects, exploring new frameworks, and contributing to open-source. The joy of going from idea → deployed app never gets old.",
    tags: ["Side Projects", "Open Source", "New Frameworks", "Hackathons"],
  },
  {
    icon: <FaBook />,
    color: "#ffca70",
    name: "Reading",
    description: "CS papers, self-development books, and social science. During my Erasmus semester I studied intercultural communication and marketing texts that completely changed how I think about people.",
    tags: ["CS Papers", "The Culture Map", "Self-Development", "Science Communication"],
  },
  {
    icon: <FaRunning />,
    color: "#ff9060",
    name: "Sports & Fitness",
    description: "Staying active keeps my mind clear. Discipline in movement translates directly to discipline in everything else.",
    tags: ["Running", "Fitness", "Discipline", "Wellbeing"],
  },
  {
    icon: <FaPlane />,
    color: "#90d8ff",
    name: "International Travel",
    description: "Lived in Tunisia, spent a semester in the Netherlands, worked remotely with teams in Austria and across North Africa. Every new context teaches me something.",
    tags: ["Tunisia 🇹🇳", "Netherlands 🇳🇱", "Austria 🇦🇹", "Cross-cultural"],
  },
  {
    icon: <FaMicrophone />,
    color: "#d880ff",
    name: "Public Speaking & Storytelling",
    description: "Hult Prize competitor, event co-organiser, and science communicator. I believe the best ideas need the best stories to go with them.",
    tags: ["Hult Prize", "Science Communication", "Digital Content", "Narrative"],
  },
  {
    icon: <FaSeedling />,
    color: "#80e8a0",
    name: "Social Impact",
    description: "Volunteered with the Red Crescent, co-founded a startup during national incubation, and now building platforms amplifying marginalised voices at a North African NGO.",
    tags: ["NGO Work", "Volunteering", "Startup", "Community"],
  },
  {
    icon: <FaBullseye />,
    color: "#ffb3d9",
    name: "Leadership & Event Organisation",
    description: "Organised multiple technology and culture events at university, coordinated cross-functional volunteer teams, and served on the Hult Prize expert committee.",
    tags: ["Event Management", "Team Coordination", "Mentorship", "Strategy"],
  },
];

// ─── Interests ────────────────────────────────────────────────────────────
const Interests = () => (
  <div className="interests-section">
    <h2 className="section-title">Interests</h2>
    <p className="interests-intro">
      Beyond the code — what drives me, what I'm learning, and what keeps me going.
    </p>

    <div className="interests-grid">
      {INTERESTS.map((item, i) => (
        <div key={i} className="interest-card" style={{ "--int-color": item.color }}>
          <div className="interest-card__icon">{item.icon}</div>
          <div>
            <div className="interest-card__name">{item.name}</div>
            <p className="interest-card__desc">{item.description}</p>
            <div className="interest-card__tags">
              {item.tags.map((t, j) => (
                <span key={j} className="interest-tag">{t}</span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Interests;
